let _initProto, _initClass;
function _applyDecs(e, t, n, r, o, i) { var a, c, u, s, f, l, p, d = Symbol.metadata || Symbol.for("Symbol.metadata"), m = Object.defineProperty, h = Object.create, y = [h(null), h(null)], v = t.length; function g(t, n, r) { return function (o, i) { n && (i = o, o = e); for (var a = 0; a < t.length; a++) i = t[a].apply(o, r ? [i] : []); return r ? i : o; }; } function b(e, t, n, r) { if ("function" != typeof e && (r || void 0 !== e)) throw new TypeError(t + " must " + (n || "be") + " a function" + (r ? "" : " or undefined")); return e; } function applyDec(e, t, n, r, o, i, u, s, f, l, p) { function d(e) { if (!p(e)) throw new TypeError("Attempted to access private element on non-instance"); } var h = [].concat(t[0]), v = t[3], w = !u, D = 1 === o, S = 3 === o, j = 4 === o, E = 2 === o; function I(t, n, r) { return function (o, i) { return n && (i = o, o = e), r && r(o), P[t].call(o, i); }; } if (!w) { var P = {}, k = [], F = S ? "get" : j || D ? "set" : "value"; if (f ? (l || D ? P = { get: _setFunctionName(function () { return v(this); }, r, "get"), set: function (e) { t[4](this, e); } } : P[F] = v, l || _setFunctionName(P[F], r, E ? "" : F)) : l || (P = Object.getOwnPropertyDescriptor(e, r)), !l && !f) { if ((c = y[+s][r]) && 7 !== (c ^ o)) throw Error("Decorating two elements with the same name (" + P[F].name + ") is not supported yet"); y[+s][r] = o < 3 ? 1 : o; } } for (var N = e, O = h.length - 1; O >= 0; O -= n ? 2 : 1) { var T = b(h[O], "A decorator", "be", !0), z = n ? h[O - 1] : void 0, A = {}, H = { kind: ["field", "accessor", "method", "getter", "setter", "class"][o], name: r, metadata: a, addInitializer: function (e, t) { if (e.v) throw new TypeError("attempted to call addInitializer after decoration was finished"); b(t, "An initializer", "be", !0), i.push(t); }.bind(null, A) }; if (w) c = T.call(z, N, H), A.v = 1, b(c, "class decorators", "return") && (N = c);else if (H.static = s, H.private = f, c = H.access = { has: f ? p.bind() : function (e) { return r in e; } }, j || (c.get = f ? E ? function (e) { return d(e), P.value; } : I("get", 0, d) : function (e) { return e[r]; }), E || S || (c.set = f ? I("set", 0, d) : function (e, t) { e[r] = t; }), N = T.call(z, D ? { get: P.get, set: P.set } : P[F], H), A.v = 1, D) { if ("object" == typeof N && N) (c = b(N.get, "accessor.get")) && (P.get = c), (c = b(N.set, "accessor.set")) && (P.set = c), (c = b(N.init, "accessor.init")) && k.unshift(c);else if (void 0 !== N) throw new TypeError("accessor decorators must return an object with get, set, or init properties or undefined"); } else b(N, (l ? "field" : "method") + " decorators", "return") && (l ? k.unshift(N) : P[F] = N); } return o < 2 && u.push(g(k, s, 1), g(i, s, 0)), l || w || (f ? D ? u.splice(-1, 0, I("get", s), I("set", s)) : u.push(E ? P[F] : b.call.bind(P[F])) : m(e, r, P)), N; } function w(e) { return m(e, d, { configurable: !0, enumerable: !0, value: a }); } return void 0 !== i && (a = i[d]), a = h(null == a ? null : a), f = [], l = function (e) { e && f.push(g(e)); }, p = function (t, r) { for (var i = 0; i < n.length; i++) { var a = n[i], c = a[1], l = 7 & c; if ((8 & c) == t && !l == r) { var p = a[2], d = !!a[3], m = 16 & c; applyDec(t ? e : e.prototype, a, m, d ? "#" + p : _toPropertyKey(p), l, l < 2 ? [] : t ? s = s || [] : u = u || [], f, !!t, d, r, t && d ? function (t) { return _checkInRHS(t) === e; } : o); } } }, p(8, 0), p(0, 0), p(8, 1), p(0, 1), l(u), l(s), c = f, v || w(e), { e: c, get c() { var n = []; return v && [w(e = applyDec(e, [t], r, e.name, 5, n)), g(n, 1)]; } }; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _setFunctionName(e, t, n) { "symbol" == typeof t && (t = (t = t.description) ? "[" + t + "]" : ""); try { Object.defineProperty(e, "name", { configurable: !0, value: n ? n + " " + t : t }); } catch (e) {} return e; }
function _checkInRHS(e) { if (Object(e) !== e) throw TypeError("right-hand side of 'in' should be an object, got " + (null !== e ? typeof e : "null")); return e; }
function _identity(t) { return t; }
/*
  this microservice should be responsible for the handling of:
  - creating new fermentations directory and metadata
  - serving fermentations metadata
  - updating fermentations metadata
  - listing fermentations data
  
  the actual process control should be running on a different microservice
*/

import { Server, enable } from "appserver";
import { ApplicationServer } from "appserver";
import { HttpServer, http } from "appserver";
import { AuthenticationService, auth } from "appserver";
import { SystemdIntegration } from "appserver";
import { HAProxyIntegration } from "appserver";
import { ApplicationConsole } from "appserver";
import * as fs from "fs";
import sleep from "sleep";
const PATH = "/var/lib/biocore/server/fermentations";

// an async generator that reads the input file chunk by chunk and yields each line
async function* readline(path) {
  const MAXCHUNKSIZE = 5000;
  var lines = [""];
  var size = fs.statSync(path).size - 1;
  var position = 0;
  var chunk;
  do {
    chunk = String.fromCharCode.apply(null, new Uint8Array(fs.readFileSync(path, {
      offset: position,
      count: MAXCHUNKSIZE
    })));
    position += MAXCHUNKSIZE;
    chunk = chunk.split("\n");
    lines[0] += chunk.shift();
    lines = lines.concat(chunk);
    while (lines.length - 1) {
      await sleep(0);
      yield lines.shift();
    }
  } while (position < size);
  return lines.shift();
}
function isJsonString(str) {
  try {
    JSON.parse(str);
  } catch (e) {
    return false;
  }
  return true;
}
const POINTS = 640;

// an async generator that reads the input file chunk by chunk and yields each line
async function* readline640(path) {
  const MAXCHUNKSIZE = 2500;
  var size = fs.statSync(path).size - 1;
  var skip = Math.round(size / POINTS);
  for (var position = 0; position < size; position += skip) {
    let chunk = String.fromCharCode.apply(null, new Uint8Array(fs.readFileSync(path, {
      offset: position,
      count: MAXCHUNKSIZE
    })));
    chunk = chunk.split("\n");
    if (isJsonString(chunk[0])) yield chunk[0];else if (isJsonString(chunk[1])) yield chunk[1];else if (isJsonString(chunk[2])) yield chunk[2];
  }

  //return lines.shift();
}
let _MyServer;
new class extends _identity {
  static [class MyServer extends Server {
    static {
      ({
        e: [_initProto],
        c: [_MyServer, _initClass]
      } = _applyDecs(this, [enable(ApplicationConsole), enable(HAProxyIntegration, {
        port: 8085,
        endpoint: /^\/api\/fermentations(?:\/.*)?$/,
        slot: "http_slot05"
      }), enable(SystemdIntegration), enable(HttpServer, {
        port: 8085
      }), enable(ApplicationServer), enable(AuthenticationService)], [[[http.get("/api/fermentations"), auth.validate()], 2, "fermentations_list"], [[http.get(/^\/api\/fermentations\/[\w-]+$/), auth.validate()], 2, "fermentations_get"], [[http.get(/^\/api\/fermentations\/[\w-]+\/data$/), auth.validate()], 2, "fermentations_getValues"], [[http.get(/^\/api\/fermentations\/[\w-]+\/startdate$/), auth.validate()], 2, "fermentation_getStartDateTime"], [[http.get(/^\/api\/fermentations\/[\w-]+\/enddate$/), auth.validate()], 2, "fermentation_getEndDateTime"]], 0, void 0, Server));
    }
    constructor() {
      _initProto(super());
    }
    async start(...args) {
      await super.start(...args);
      console.log("biocore fermentations microservice started.");
    }
    async stop(...args) {
      await super.stop(...args);
      console.log("biocore fermentations microservice stopped.");
    }
    getFermentations() {
      let result = fs.readdirSync(PATH).filter(function (name) {
        return name != "." && name != "..";
      }).map(function (name) {
        return PATH + "/" + name + "/parameters.json";
      }).map(function (path) {
        var arrayBuffer = fs.readFileSync(path);
        var str = String.fromCharCode.apply(null, new Uint8Array(arrayBuffer));
        var json = JSON.parse(str);
        return json;
      });
      return result;
    }
    getFermentation(id) {
      var arrayBuffer = fs.readFileSync(`${PATH}/${id}/parameters.json`);
      var str = new TextDecoder().decode(new Uint8Array(arrayBuffer));
      var json = JSON.parse(str);
      return json;
    }

    //get the list of fermentations
    async fermentations_list(request) {
      let fermentations = this.getFermentations();
      return new Response(JSON.stringify(fermentations), {
        status: 200,
        headers: {
          "Content-Type": "application/json"
        }
      });
    }

    //get metadata of a specific fermentation
    async fermentations_get(request) {
      const url = new URL(request.url);
      const parts = url.pathname.split("/");

      // last path segment is your id
      const id = parts[parts.length - 1];
      var arrayBuffer = fs.readFileSync(`${PATH}/${id}/parameters.json`);
      var str = new TextDecoder().decode(new Uint8Array(arrayBuffer));
      return new Response(str, {
        status: 200,
        headers: {
          "Content-Type": "application/json"
        }
      });
    }
    async fermentations_getValues(request) {
      const url = new URL(request.url);
      const parts = url.pathname.split("/");
      const id = parts[parts.length - 2];

      //TODO: not implemented
      const from = new Date("2000-01-01");
      const to = new Date("2000-01-01");
      var values = [];
      var path = `${PATH}/${id}/values.json`;
      for await (const line of readline640(path)) {
        try {
          var record = JSON.parse(line);
          values.push(record);
        } catch (e) {
          console.warn(`Invalid entry in datafile ${path} at line ?. Skipped.`);
        }
      }
      return new Response(JSON.stringify(values), {
        status: 200,
        headers: {
          "Content-Type": "application/json"
        }
      });
    }
    async fermentation_getStartDateTime(request) {
      const url = new URL(request.url);
      const parts = url.pathname.split("/");
      const id = parts[parts.length - 2];
      if (fs.statSync(`${PATH}/${id}/values.json`).size == 0) {
        return null;
      }
      let iterator = readline(`${PATH}/${id}/values.json`);
      let record = (await iterator.next()).value;
      iterator.return();
      record = JSON.parse(record);
      return new Response(record.dt, {
        status: 200,
        headers: {
          "Content-Type": "text/plain"
        }
      });
    }
    async fermentation_getEndDateTime(request) {
      const url = new URL(request.url);
      const parts = url.pathname.split("/");
      const id = parts[parts.length - 2];
      if (fs.statSync(`${PATH}/${id}/values.json`).size == 0) {
        return null;
      }
      let iterator = readline(`${PATH}/${id}/values.json`, true);
      let record = (await iterator.next()).value;
      iterator.return();
      record = JSON.parse(record);
      return new Response(record.dt, {
        status: 200,
        headers: {
          "Content-Type": "text/plain"
        }
      });
    }
  }];
  constructor() {
    super(_MyServer), (() => {
      new this();
    })(), _initClass();
  }
}();